import React, { useMemo } from 'react';
import { Marker } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { customIcon } from '../../../utils/unifiedMapUtils';
import { getDistrictColor } from '../../../utils/districtColorUtils';

const DistrictMapMarkers = ({ schools, selectedHeadline, onSchoolSelect }) => {
  const markersData = useMemo(() => {
    // First, deduplicate schools by UUID to prevent duplicate keys
    const uniqueSchools = schools.reduce((acc, school) => {
      if (!acc.some(existing => existing.uuid === school.uuid)) {
        acc.push(school);
      }
      return acc;
    }, []);
    
    return uniqueSchools.map(school => {
      const color = getDistrictColor(school, selectedHeadline);
      const isCharter = school.operational_model === 'Charter';

      return {
        ...school,
        color,
        isCharter
      };
    });
  }, [schools, selectedHeadline]);

  return (
    <MarkerClusterGroup
      chunkedLoading
      spiderfyOnMaxZoom={true}
      zoomToBoundsOnClick={true}
      maxClusterRadius={40}
      disableClusteringAtZoom={12}
    >
      {markersData.map((school) => (
        <Marker
          key={school.uuid}
          position={[school.latitude, school.longitude]}
          icon={customIcon({
            color: school.color,
            isCharter: school.isCharter,
            isSelected: false
          })}
          eventHandlers={{
            click: () => onSchoolSelect(school)
          }}
        />
      ))}
    </MarkerClusterGroup>
  );
};

export default DistrictMapMarkers;